









import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system";
import { IComboSelectBehavior, IComboOption } from "../../../../domain/format/objects";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";

@Component
export default class ComboSelectBehaviorEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IComboSelectBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IComboSelectBehavior) => T, defaultValue: T) => T;

  @Prop()
  commonComponents: CommonComponentsContainer;

  get options(): IComboOption[] {
    return this.readPropertyOrDefault(s => s.options, []);
  }

  set options(value: IComboOption[]) {
    this.writePropertyWhenValid(s => s.options = value);
  }

  get pageKeys(): number[] {
    return this.commonComponents.pages.map(v => v.pageKey().getValue());
  }

  async showComboSelectOptionEditDialog() {
    const dialog = this.commonComponents.getDialogs().getComboOptionEditDialog();
    const comboOptions = await dialog.show(this.options, this.pageKeys);
    if (!comboOptions) { return; }
    this.options = comboOptions;
  }
}
